import PortalLayout from '../PortalLayout';
import { EmployeeProvider, useEmployee } from './context/EmployeeContext';
import { NAV } from './nav';
import { useAuth } from '../../auth/AuthContext';
import { userLabel, userInitials } from '../../auth/roles';

function EmployeeLayoutInner() {
  const { user } = useAuth();
  const { refreshing } = useEmployee();

  return (
    <PortalLayout
      navSections={NAV}
      brandRole="My benefits"
      userLabel={userLabel(user, 'Employee')}
      userInitials={userInitials(user)}
      loading={refreshing}
    />
  );
}

/* Employee self-service portal shell. Everything here is scoped to the
   signed-in person's own records (GET /me/...) — see EE-01 through EE-03
   in BrandonUserStoryAPI.md. No employer-group scope selector: an
   employee isn't looking across a group, just their own cover.
   Wraps every employee route in EmployeeProvider, same pattern as
   icib-admin/DashboardLayout.js, so every story view (EE-01..03) shares
   the one `db`/refresh(). RequireRole (see src/App.js) already guarantees
   `user` is set and role === 'employee' by the time this renders. */
function EmployeeLayout() {
  return (
    <EmployeeProvider>
      <EmployeeLayoutInner />
    </EmployeeProvider>
  );
}

export default EmployeeLayout;
